import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { IUserInfo } from '../../../ts/models/IUserInfo';
import { SetOwner, SetOwnerSucceeded } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SetOwnerAction extends Action {
  items: IContentInfo[];
}

export function setOwner(items: IContentInfo[]): SetOwnerAction {
  return {
    type: SetOwner,
    items
  };
}

export const isSetOwnerAction = isActionFactory<SetOwnerAction>(SetOwner);

export interface SetOwnerSucceededAction extends Action {
  items: IContentInfo[];
  owner: IUserInfo;
}

export function setOwnerSucceeded(items: IContentInfo[], owner: IUserInfo): SetOwnerSucceededAction {
  return {
    type: SetOwnerSucceeded,
    items,
    owner
  };
}

export const isSetOwnerSucceededAction = isActionFactory<SetOwnerSucceededAction>(SetOwnerSucceeded);
